import clsx from "clsx"
import React from "react"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import { faCircleArrowLeft } from "@fortawesome/free-solid-svg-icons/faCircleArrowLeft";
import { faCircleXmark } from "@fortawesome/free-solid-svg-icons/faCircleXmark";
const estilosAbas = require('./abas.module.scss').default

export type AbasProps = {
    abas: {
        nome: string
    }[]
    nomeAbaSelecionada: string
    id?:string
    onAbaSelecionada: (nome:string) => void
    onVoltar?: () => void;
    onLimpar?: () => void;
    exibirBotaoVoltar?: boolean;
    exibirBotaoLimpar?: boolean;
}

export const Abas = (props: AbasProps) => {
    return <>
        <div>
            {
                props.exibirBotaoVoltar &&
                <>
                    <button
                        className={clsx(estilosAbas.buttonIconeAction, 'no-global-button')}
                        id={`${props.id}-Aba_Botaovoltar`}
                        onClick={() => {
                            props.onVoltar();
                        }}
                    >
                        <FontAwesomeIcon
                            className={"material-icons"}
                            color="#f25713"
                            icon={faCircleArrowLeft}
                        />
                        Voltar
                    </button>
                    <br />
                </>
            }
            {
                props.exibirBotaoLimpar &&
                <button
                    className={clsx(estilosAbas.buttonIconeAction, 'no-global-button')}
                    id={`${props.id}-Aba_BotaoLimpar`}
                    onClick={() => {
                        props.onLimpar();
                    }}
                >
                    <FontAwesomeIcon
                        className={"material-icons"}
                        color="#f25713"
                        icon={faCircleXmark}
                    />
                    Limpar
                </button>
            }
        </div>
        <div className="_border-b">
            <div className={estilosAbas.barraFormaDePagamentoContainer}>
                {props.abas.map(aba => <button
                    key={aba.nome}
                    id={`${props.id}-Aba_Botao_${aba.nome}`}
                    onClick={() => props.onAbaSelecionada(aba.nome)}
                    className={clsx(
                        'no-global-button',
                        aba.nome == props.nomeAbaSelecionada ? estilosAbas.abaSelecionada : '',
                        estilosAbas.aba)}>
                    {aba.nome}
                </button>)}
            </div>
        </div>

    </>
}
